import { Button, TOUCH } from "@nymbl/nos2-rules";
import { CalendarDays } from "lucide-react";
import { useConnectCalendar } from "@/hooks/use-calendar";
import type { CalendarConnectionState } from "@/schemas/calendar";

interface CalendarConnectRowProps {
  connection: CalendarConnectionState;
}

function currentPath(): string {
  return `${window.location.pathname}${window.location.search}`;
}

/**
 * One slim row offering Connect calendar (or Reconnect when Microsoft stopped answering for the
 * stored grant). Nothing when Microsoft sign-in is not set up or the calendar is connected.
 */
export function CalendarConnectRow({ connection }: CalendarConnectRowProps) {
  const connect = useConnectCalendar(currentPath);
  if (connection !== "not_connected" && connection !== "reconnect") return null;
  const reconnect = connection === "reconnect";

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border px-4 py-2">
      <p className="flex items-center gap-2 text-sm">
        <CalendarDays className="size-4 shrink-0 text-muted-foreground" aria-hidden="true" />
        {reconnect
          ? "Your calendar needs to be reconnected"
          : "Fill your week from your Outlook calendar"}
      </p>
      <Button
        variant="outline"
        className={TOUCH}
        disabled={connect.pending}
        onClick={connect.connect}
      >
        {reconnect ? "Reconnect calendar" : "Connect calendar"}
      </Button>
    </div>
  );
}
